export const SAMPLE_TEST_MARKER = "sample_test_agilysys";

/** True when any nested string contains the demo sample marker. */
export const containsSampleTestValue = (value: unknown): boolean => {
  if (value == null) {
    return false;
  }
  if (typeof value === "string") {
    return value.toLowerCase().includes(SAMPLE_TEST_MARKER);
  }
  if (typeof value === "number" || typeof value === "boolean") {
    return false;
  }
  if (Array.isArray(value)) {
    return value.some((entry) => containsSampleTestValue(entry));
  }
  if (typeof value === "object") {
    return Object.values(value as Record<string, unknown>).some((entry) =>
      containsSampleTestValue(entry),
    );
  }
  return false;
};

export const isSampleTestRow = (row: Record<string, unknown>): boolean =>
  containsSampleTestValue(row);

/** Drop autocomplete labels / codes that point at demo sample data. */
export const filterSampleTestStrings = (values: string[]): string[] =>
  values.filter((value) => !containsSampleTestValue(value));

/** Strip demo/sample rows from list payload sections before Excel export or import. */
export const removeSampleTestFromPayload = <T extends Record<string, unknown>>(
  data: T,
): T => {
  const result = { ...data } as Record<string, unknown>;

  Object.keys(result).forEach((key) => {
    if (Array.isArray(result[key])) {
      result[key] = (result[key] as Record<string, unknown>[]).filter(
        (row) => !isSampleTestRow(row),
      );
    }
  });

  return result as T;
};
